import React from 'react'

const SubprodBanner: React.FC = () => {
  const isProd = process.env.REACT_APP_ENV === 'prod'
  const isLocal = process.env.REACT_APP_ENV === 'local'

  if (isProd || isLocal) return null

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        width: '100%',
        height: '48px',
        zIndex: 9999,
        backgroundColor: '#FFC107',
        color: '#333',
        textAlign: 'center',
        lineHeight: '48px',
        fontWeight: 'bold',
      }}
    >
      You are viewing a SUBPROD environment
    </div>
  )
}

export default SubprodBanner
